export default {
  staleImageError: {
    title: 'Nieaktualna klatka',
    description: 'Klatka z kamery jest nieaktualna (nieświeża)',
  },
};
